import { openExternalLink } from '../../../../infrastructure';
import clueLinkSvg from './clue_link.svg';
import './ClueLink.css';

type ClueLinkProps = {
  href: string;
  onClick?: () => void;
};

/** Figma clue_link (161:23948) — «Ссылка-подсказка». */
export function ClueLink({ href, onClick }: ClueLinkProps) {
  return (
    <a
      className="quiz-clue-link quiz-content-enter"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Ссылка-подсказка"
      onClick={(event) => {
        void openExternalLink(href, event);
        onClick?.();
      }}
    >
      <img
        className="quiz-clue-link__text"
        src={clueLinkSvg}
        alt=""
        draggable={false}
      />
    </a>
  );
}
